import { render, staticRenderFns } from "./home_barigad_ajil_bair_zar.vue?vue&type=template&id=6b1b8b52&scoped=true&"
import script from "./home_barigad_ajil_bair_zar.vue?vue&type=script&lang=js&"
export * from "./home_barigad_ajil_bair_zar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b8b52",
  null
  
)

export default component.exports